module.exports = __webpack_public_path__ + "static/media/filled-heart.f2610513.svg";